// IMPORT LIBS
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT FUNCTIONS
import { swipersInit } from './functions/sliders';
import { showPartialsFixed } from './functions/partialsFixed';
import { showNavbarDropdown, showSidebarDropdown } from './functions/dropdowns';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';


  // INIT LAZY LOADING
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.js-header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

  // FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBARS
  showNavbarDropdown('.js-drop-target.dropdownList', '.js-drop-content.dropdownList', 0);
  showNavbarDropdown('.js-drop-target.dropdownList', '.js-drop-content.dropdownList', 1);

  // FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBAR MENUS
  showSidebarDropdown('.sidebar-link.dropdownList','.sidebar-link-dropdown.dropdownList', 0);

  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  sidebarFixedBehavior('.js-sidebar-button');

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  setTimeout(() => {
    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-high-title', 992);
    handleSetMoreHeight('.js-high-desc', 992);
    handleSetMoreHeight('.js-sales-title', 992);
    handleSetMoreHeight('.js-sales-desc', 992);
  }, 500);

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});
